import React from 'react';
import connectStatic from 'app/utils/connectStatic';
import Page from 'app/containers/parts/Page';
import StaticContent from 'app/components/static/StaticContent';
import t from 'app/utils/translate';

const GambleResponsiblyContent = connectStatic({
  index: 'gamble_responsibly',
  title: t('Gamble Responsibly'),
})(StaticContent);

function GambleResponsibly() {
  return (
    <Page>
      <GambleResponsiblyContent />
    </Page>
  );
}

export default GambleResponsibly;
